export enum Role {
  admin = 'admin',
  member = 'member'
}

export enum Collection {
  vendors = 'vendors',
  vendorUsers = 'vendorUsers',
  consumers = 'consumers',
  countries = 'countries',
  roles = 'roles',
  items = 'items',
  categories = 'categories',
  giftBundles = 'giftBundles',
  gifts = 'gifts',
  recipients = 'recipients',
  orders = 'orders',
  bankAccounts = 'bankAccounts',
  credits = 'credits',
  installments = 'installments'
}

export enum StoreKey {
  authState = 'bigmochi::authState',
  userType = 'bigmochi::userType',
  migrantProfile = 'bigmochi::migrantProfile',
  vendorProfile = 'bigmochi::vendorProfile',
  companyProfile = 'bigmochi::companyProfile',
  customClaims = 'bigmochi::customClaims',
  homeCountry = 'bigmochi::homeCountry',
  shopCountry = 'bigmochi::shopCountry',
  selectedCategory = 'bigmochi::selectedCategory',
  cart = 'bigmochi::cart',
  redirectTo = 'bigmochi:redirectTo',
  didKycModalAppearedKey = 'bigmochi::didKycModalAppeared'
}

export enum Functions {
  signupConsumer = 'users-signupConsumer',
  signupVendor = 'users-signupVendor',
  updateVendor = 'users-updateVendor',
  updateVendorUser = 'users-updateVendorUser',
  updateConsumer = 'users-updateConsumer',
  updateConsumerWorkPermit = 'users-updateConsumerWorkPermit',
  inviteVendorUser = 'users-inviteVendorUser',
  signupVendorUser = 'users-signupVendorUser',
  deleteVendorUser = 'users-deleteVendorUser',
  createItemListing = 'items-createItem',
  updateItemListing = 'items-updateItem',
  deleteItemListing = 'items-deleteItem',
  updateCartItems = 'orders-updateCartItems',
  updateOrder = 'orders-updateOrder',
  placeOrder = 'orders-placeOrder',
  updateOrderItemStatus = 'orders-updateOrderItemStatus',
  createRecipient = 'recipients-createRecipient',
  updateRecipient = 'recipients-updateRecipient',
  deleteRecipient = 'recipients-deleteRecipient',
  createStripePaymentIntent = 'payments-createStripePaymentIntent',
  payWithCredits = 'payments-payWithCredits',
  createGift = 'gifts-createGift',
  createGiftBundle = 'gifts-createGiftBundle',
  updateGift = 'gifts-updateGift',
  updateGiftBundle = 'gifts-updateGiftBundle',
  deleteGift = 'gifts-deleteGift',
  deleteGiftBundle = 'gifts-deleteGiftBundle',
  payNextInstallment = 'installments-payNextInstallment'
}

export enum ProviderId {
  facebook = 'facebook.com',
  google = 'google.com'
}

export enum AppError {
  formInvalid = 'form/invalid',
  unregisteredAccount = 'auth/unregistered-account',
  currentPasswordIncorrect = 'editProfile/incorrect-password',
  currentPasswordBlank = 'form/passwordblank',
  emailInvited = 'auth/email-invited',
  shippingUnavailable = 'shop/shipping-unavailable'
}

/**
 * Refer to this link for possible error codes
 * https://firebase.google.com/docs/reference/js/firebase.auth.Auth?authuser=0#createuserwithemailandpassword
 */
export enum FirebaseError {
  authEmailAlreadyInUse = 'auth/email-already-in-use',
  authInvalidEmail = 'auth/invalid-email',
  authOperationNotAllowed = 'auth/operation-not-allowed',
  authWeakPassword = 'auth/weak-password',
  authUserDisabled = 'auth/user-disabled',
  authUserNotFound = 'auth/user-not-found',
  authWrongPassword = 'auth/wrong-password',
  authInvalidVerifyCode = 'auth/invalid-verification-code',
  authInvalidPhonenumber = 'auth/invalid-phone-number'
}

export enum APIError {
  alreadySignedUp = 'You are already signed up.'
}

export enum Countries {
  singapore = 'Singapore',
  indonesia = 'Indonesia',
  philippines = 'Philippines'
}

export enum AccessType {
  read = 'read',
  write = 'write'
}

export enum TableError {
  limitExceededDiscount = 'Limit exceeded',
  notANumber = 'Please enter a number'
}

export enum Listing {
  enabled = 'Active',
  disabled = 'Disabled'
}

export enum PaginationLimit {
  listings = 9,
  tables = 10
}

export enum Relationship {
  self = '_SELF_'
}

export enum DeliveryRegion {
  any = '_ANY_'
}

export enum OrderStatus {
  inCart = 'inCart',
  checkedOut = 'checkedOut',
  placed = 'placed',
  approved = 'approved',
  closed = 'closed',
  rejected = 'rejected'
}

export enum OrderItemStatus {
  inCart = 'inCart',
  checkedOut = 'checkedOut',
  placed = 'placed',
  processing = 'processing',
  disptached = 'disptached',
  delivered = 'delivered',
  canceled = 'canceled',
  rejected = 'rejected'
}

export enum WorkPermitButtonStatus {
  loading = 'Uploading..',
  uploaded = 'Uploaded',
  upload = 'Upload Work Permit'
}

export enum PaymentMethod {
  paynow = 'paynow',
  card = 'card',
  cash = 'cash',
  credits = 'credits',
  hoolah = 'hoolah',
  dash = 'dash'
}

export enum ButtonName {
  add = 'ADD',
  edit = 'EDIT',
  delete = 'DELETE'
}
